<template>
  <div id="aqt_head">
    <div class="head_content">
      <router-link to="/Index" class="img_logo">
        <img src="../assets/img/logo.png" class="logo_img" alt=""/>
      </router-link>

      <ul class="nav_top">
        <router-link to="/Index" active-class="active" class="nav-top_item">公司首页</router-link>
        <router-link to="/Server" active-class="active" class="nav-top_item">公司服务</router-link>
        <router-link to="/Case" active-class="active" class="nav-top_item">公司案例</router-link>
        <router-link to="/Product" active-class="active" class="nav-top_item">公司产品</router-link>
<!--        <router-link to="/News" active-class="active" class="nav-top_item">公司新闻</router-link>-->
        <router-link to="/Personal" active-class="active" class="nav-top_item">关于我们</router-link>
      </ul>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
#aqt_head {
  width: 100%;
  height: 60px;
  background-color: #1D3662;
  position: fixed;
  top: 0px;
  z-index: 111;

  .head_content {
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .img_logo {
      width: 20%;
      //margin-top: 1.2%;
      display: flex;
      justify-content: center;
      align-items: center;
      .logo_img {
        height: 70%;
        line-height: 100%;
      }
    }

    .nav_top {
      width: 75%;
      height: 100%;
      display: flex;
      flex-direction: row;

      .nav-top_item {
        width: 20%;
        height: 100%;
        line-height: 60px;
        font-size: 15px;
        text-align: center;
        color: #D3DFFF;
        cursor: pointer;

        &.active {
          color: #ec4949;
        }

      }
    }
  }
}
</style>
